import {DOCUMENT, Location} from '@angular/common';

import {Component, EventEmitter, Inject, Input, OnInit, Output, Renderer2} from '@angular/core';
import {animate, AnimationEvent, state, style, transition, trigger,} from '@angular/animations';
import {environment} from '@env/environment';
import {DeviceService, EventTrackerService, HttpService, LogService} from '@app/core';
import {
  infoPlayer,
  IPurchase,
  PlayButtonMode,
  purchaseButtonActionType,
  subscriptionButtonStateType
} from '../pdp-model';
import {iBook, ProductTypeEnum} from '@app/interfaces/iBook';
import {iProduct} from '@app/interfaces/IProduct';
import {IndicatorService} from '@app/shared';
import {slideInUpOnEnterAnimation} from '@app/animation/slideDownToUp';
import {Router} from '@angular/router';
import {NotificationService} from '@app/shared/notification/notification.service';
import {PDPService} from "@app/app/pdp/pdp/pdp.service";
import {ClientTypeEnum} from "@app/helper/ClientTypeEnum";
import {AppParametersService} from "@app/core/token/app-parameters.service";

@Component({
  selector: 'navaar-dialog-download-pdp',
  templateUrl: './dialog-download-pdp.component.html',
  styleUrls: ['./dialog-download-pdp.component.scss'],
  animations: [
    slideInUpOnEnterAnimation({anchor: 'slidePopupDownload'}),
    trigger('fading', [
      state('fadeIn', style({opacity: 1})),
      state('fadeOut', style({opacity: 0})),
      transition('fadeOut => fadeIn', [
        animate(`400ms ease-in`)]
      ),
      transition('fadeIn => fadeOut', [
        animate(`800ms ease-out`)]
      )
    ])
  ]
})
export class DialogDownloadPDPComponent implements OnInit {
  @Input() public isLogin: boolean = false;
  @Input() public purchase: IPurchase;
  @Input() public dataBook: iBook;
  @Input() public product: iProduct;
  @Input() public showPopupDownload: boolean = false;
  @Output() public showPopupDownloadChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public openMarketDialog: EventEmitter<purchaseButtonActionType> = new EventEmitter<purchaseButtonActionType>();
  @Output() public refreshStatePurchase: EventEmitter<void> = new EventEmitter<void>();

  public slideAnimationFadingPopupDownload: string = '';
  public slideAnimationPopupDownload: string = '';
  public environment = environment;
  public playButtonMode: typeof PlayButtonMode = PlayButtonMode;
  public purchaseButtonActionType: typeof purchaseButtonActionType = purchaseButtonActionType;
  public subscriptionButtonStateType: typeof subscriptionButtonStateType = subscriptionButtonStateType;
  public clientType:typeof ClientTypeEnum =ClientTypeEnum;
  constructor(
    private readonly pdpServices: PDPService,
    private readonly location: Location,
    private readonly log: LogService,
    public readonly appParameterService: AppParametersService,
    private readonly notification: NotificationService,
    private readonly router: Router,
    private readonly http: HttpService,
    private readonly indicator: IndicatorService,
    private readonly eventTracker: EventTrackerService,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly render: Renderer2,
    public readonly device: DeviceService) {
  }

  ngOnInit(): void {
  }

  public hideDownloadPopup() {
    this.render.removeStyle(this.document.body, 'overflow');
    this.slideAnimationPopupDownload = 'void';
  }

  public onSlideStartPopupDownload(event: AnimationEvent) {
    if (event.fromState === 'void') {
      this.slideAnimationFadingPopupDownload = 'fadeIn';
    }
    if (event.toState === 'void') {
      this.slideAnimationFadingPopupDownload = 'fadeOut';
    }
  }

  public onSlidePopupDownload(event: AnimationEvent) {
    if (event.toState === 'void' && this.showPopupDownload) {
      this.slideAnimationPopupDownload = '';
      this.showPopupDownloadChange.emit(false);
      if (this.location.path(true).includes('#modalOpened'))
        this.location.back();
    }
  }

  public getMainPriceForDiscount(): number {
    let price: number = this.purchase.purchaseButtonState.stateDiscountedPrice;
    this.purchase.discounts.map(c => {
      price += (c.discountValue / 10);
    });
    return price;
  }

  public calculateDiscount(index) {
    return (this.getMainPriceForDiscount() - (this.purchase.discounts[index - 1].discountValue / 10));
  }

  public async goToSubscription(state: subscriptionButtonStateType) {
    switch (state) {
      case subscriptionButtonStateType.noSubscription:
        if (this.device.isAndroid() && this.device.isMarkets()) {
          this.device.goToCustomTab('subscription/plans', 'profile');
          this.logItem('x_btn_get_item', {
            'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
            'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
            'x_button_type': 'subscription'
          });
          this.hideDownloadPopup();
        } else {
          this.indicator.show(true);
          this.logItem('x_btn_get_item', {
            'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
            'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
            'x_button_type': 'subscription'
          });
          this.router.navigate(['./subscription', 'plans']).then(_ => this.hideDownloadPopup());
        }
        break;
      case subscriptionButtonStateType.getBySubscription:
        this.indicator.showHude();
        this.http.post(`/api/orders/app-nopayment?productId=${this.dataBook.products[0]['productId']}`, {})
          .subscribe((response) => {
            this.logItem('x_btn_get_item', {
              'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
              'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
              'x_button_type': 'subscription'
            });
            this.pdpServices.play(this.getInfoPlay());
            this.indicator.hideHude();
            this.hideDownloadPopup();
            this.refreshStatePurchase.emit();
          }, (error) => {
            this.indicator.hideHude();
            this.hideDownloadPopup();
            if (error && error.hasOwnProperty('error') && error.error.hasOwnProperty('message')) {
              this.notification.setNotification({text: error.error.message, type: 'error', timeout: 5000});
            }
          });
        break;
      case subscriptionButtonStateType.playByNewSubscription:
        this.indicator.showHude();
        this.purchaseNewSubscription();
        this.hideDownloadPopup();
        break;
    }
  }

  private purchaseNewSubscription() {
    this.pdpServices.purchaseNewSubscriptionMode(this.dataBook.products[0]['productId']).subscribe((response) => {
      this.indicator.hideHude();
      this.pdpServices.play(this.getInfoPlay());
      this.logItem('x_btn_get_item', {
        'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
        'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
        'x_button_type': 'subscription'
      });
    }, (error) => {
      this.hideDownloadPopup();
      this.indicator.hideHude();
    });
  }

  public async onPurchase() {
    let x_button_type = 'purchase';
    switch (this.purchase.purchaseButtonState.purchaseButtonAction) {
      case purchaseButtonActionType.library:
        if (this.device.isAndroid()) {
          (window as any).Android.goToLibraryTab();
        } else if (this.device.isIOS()) {
          (window as any).webkit.messageHandlers.callbackHandler.postMessage("openBook");
        }
        this.hideDownloadPopup();
        break;
      case purchaseButtonActionType.getFree:
      case purchaseButtonActionType.getBySubscription:
        this.indicator.showHude();
        x_button_type = 'x_btn_download_no_payment'
        this.logItem('x_btn_get_item', {
          'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
          'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
          'x_button_type': x_button_type
        });
        this.http.post(`/api/orders/app-nopayment?productId=${this.dataBook.products[0]['productId']}`, {})
          .subscribe((response) => {
            this.pdpServices.play(this.getInfoPlay());
            this.indicator.hideHude();
            this.refreshStatePurchase.emit();
            this.hideDownloadPopup();
          }, (error) => {
            this.hideDownloadPopup();
            this.indicator.hideHude();
            if (error && error.hasOwnProperty('error') && error.error.hasOwnProperty('message')) {
              this.notification.setNotification({text: error.error.message, type: 'error', timeout: 5000});
            }
          });
        return;
      case purchaseButtonActionType.purchase:
        this.log.logger('Sending purchase with ' + this.dataBook.products[0]['productId']);
        let productId = this.dataBook.products[0]['productId'];
        if (this.purchase?.subscriptionButtonState?.subscriptionButtonState == subscriptionButtonStateType.getBySubscription) {
          // add libraryTransitionType to product id
          productId += '@7';
        }
        this.device.purchaseBook(productId);
        this.hideDownloadPopup();
        break;
      case purchaseButtonActionType.showSubscriptionPlans:
        x_button_type = 'x_btn_download_popup_SubscriptionPlans';
        this.logItem('x_btn_get_item', {
          'x_subscription_status': (this.purchase.subscriptionButtonState || {})?.subscriptionButtonState,
          'x_purchase_status': this.purchase?.purchaseButtonState?.purchaseButtonAction,
          'x_button_type': x_button_type
        });
        this.indicator.show(true);
        this.router.navigate(['./subscription', 'plans']).then(_ => this.hideDownloadPopup());
        return;
      case purchaseButtonActionType.HasCafeBazaarCredit:
      case purchaseButtonActionType.HasNotEnoughCafeBazaarCredit:
        x_button_type = 'CB_purchase';
        this.hideDownloadPopup();
        this.openMarketDialog.emit(this.purchase.purchaseButtonState.purchaseButtonAction);
        break;
      case purchaseButtonActionType.Archived:
        x_button_type = 'x_btn_download_popup_Archived';
        this.logItem('x_btn_get_item', {
          'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
          'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
          'x_button_type': x_button_type
        });
        this.indicator.show(true);
        this.router.navigate(['./archive']).then(z => this.hideDownloadPopup());
        return;
    }

    this.logItem('x_btn_get_item', {
      'x_subscription_status': (this.purchase.subscriptionButtonState || {}).subscriptionButtonState,
      'x_purchase_status': this.purchase.purchaseButtonState.purchaseButtonAction,
      'x_button_type': x_button_type
    });
  }

  public logItem(name: string, obj: object) {
    let _obj = {
      ...{
        item_id: this.dataBook?.identifier,
        'audiobook-title': this.dataBook?.title
      }, ...obj
    };
    this.eventTracker.logEvent(name, _obj);
  }

  public getClassName(): 'subscription' | 'blue' {
    switch (this.purchase.purchaseButtonState.purchaseButtonAction) {
      case purchaseButtonActionType.disabled:
      case purchaseButtonActionType.getBySubscription:
      case purchaseButtonActionType.showSubscriptionPlans:
        return 'subscription';
      case purchaseButtonActionType.library:
      case purchaseButtonActionType.Archived:
      case purchaseButtonActionType.getFree:
      case purchaseButtonActionType.purchase:
      case purchaseButtonActionType.HasCafeBazaarCredit:
      case purchaseButtonActionType.HasNotEnoughCafeBazaarCredit:
        return 'blue';
    }
  }

  private getInfoPlay(): infoPlayer {
    const info: infoPlayer = {
      audioBookId: this.dataBook.audioBookId,
      title: this.dataBook.title,
      image: `${environment.imageUrl}/content/books/${this.dataBook.audioBookId}/pic.jpg?t=${this.dataBook.recordVersion}`,
      isOwner: true,
      identifier: this.dataBook.identifier,
      genreIdentifier: this.dataBook.genres[0]?.parentIdentifier,
      genreTitle: this.dataBook.genres[0]?.parentTitle
    };
    switch (this.dataBook.contentType) {
      case ProductTypeEnum.AudioBook:
      case ProductTypeEnum.Capsule:
        info.narrators = this.dataBook['narrators'][0] && (this.dataBook['narrators'][0].firstName + ' ' + this.dataBook['narrators'][0].lastName);
        info.author = (this.dataBook['authors'][0]) && (this.dataBook['authors'][0].firstName + ' ' + this.dataBook['authors'][0].lastName);
        break;
      case ProductTypeEnum.AudioSeries:
        info.author = (this.dataBook['authors'][0]) && (this.dataBook['authors'][0].firstName + ' ' + this.dataBook['authors'][0].lastName);
        break;
      case ProductTypeEnum.Podcast:
      default:
        info.author = "";
    }
    return info;
  }
}
